export interface DataTableInterface {
    paginate: boolean,
    perPage?: number,
    page?: number,
    cursor?: string | null,
    sortBy?: string | null,
    sortDirection?: sortDirectionEnum,
    query?: string | null,
}

export enum sortDirectionEnum {
    Ascending = 'asc',
    Descending = 'desc',
}